import React from "react";
import createReactClass from "create-react-class";
import moment from "moment";

export default createReactClass({
  displayName: "Root",
  render() {
    if (this.props.blogs.length === 0) return "";
    const blogs = this.props.blogs.map(function(blog) {
      return (
        <div key={blog.id}>
          <p className="mb10">
            <a href={`/blogs/${blog.id_to_param}`}>
              {moment(blog.publish_datetime).format("YYYY.MM.DD")} {blog.title}
            </a>
          </p>
        </div>
      );
    });
    return (
      <div className="block mb50">
        <h2 className="font-size-28">
          <i className="fas fa-newspaper" />&nbsp;ブログ一覧
        </h2>
        <div className="">{blogs}</div>
      </div>
    );
  },
});
